<script lang="ts">
  import { createQuery } from '@tanstack/svelte-query';
  import Button from '../ui/Button.svelte';
  import { myRoomsQueryOptions, orderedRooms } from '../queries/rooms';

  /** Turn-taking rooms this profile belongs to, with rooms owing a turn first. */
  interface Props {
    credential: string | null;
    profileGeneration: number;
    openRoom: (code: string) => void;
  }
  let { credential, profileGeneration, openRoom }: Props = $props();

  const query = createQuery(() => myRoomsQueryOptions(credential, profileGeneration));
  const rooms = $derived(orderedRooms(query.data));
</script>

{#if rooms.length}
  <nav class="my-rooms" aria-label="Your rooms">
    <h2>Your rooms</h2>
    <ul>
      {#each rooms as room (room.code)}
        <li>
          <Button
            class="menu-option my-room"
            aria-label={`Room ${room.code}${room.needsAction ? (room.phase === 'results' ? ', next round' : ', your turn') : ''}`}
            onclick={() => openRoom(room.code)}
            ><span
              ><strong>{room.code}</strong><small
                >{room.phase === 'lobby' ? 'waiting to start' : `round ${room.round}`} · {room.members}
                {room.members === 1 ? 'player' : 'players'}</small
              ></span
            >{#if room.needsAction}<span class="turn-badge"
                >{room.phase === 'results' ? 'next round' : 'your turn'}</span
              >{:else}<span class="turn-quiet">waiting</span>{/if}</Button
          >
        </li>
      {/each}
    </ul>
  </nav>
{/if}

<style>
  .my-rooms {
    width: 100%;
    display: grid;
    gap: 10px;
  }
  .my-rooms h2 {
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: var(--theme-muted-text);
    margin: 0;
  }
  .my-rooms ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    gap: 10px;
  }
  .turn-badge,
  .turn-quiet {
    margin-left: auto;
    font-size: 12px;
    font-weight: 700;
    border-radius: 999px;
    padding: 2px 10px;
    flex-shrink: 0;
  }
  .turn-badge {
    background: var(--theme-primary);
    color: var(--theme-primary-text);
  }
  .turn-quiet {
    color: var(--theme-muted-text);
    background: var(--theme-surface);
  }
</style>
